<template>
  <div id="main" :style="{height:(screenHeight)+'px'}">
    <van-image :src="require('../../assets/poster.png')" style="display: block !important;"/>
    <template v-if="role === 'passenger'">
      <van-tabs v-model="active" sticky color="#FEB013" title-active-color="#FEB013" @click="checkTab">
        <van-tab v-for="(value, key) in routeType" :key="key" :title="'路线'+value.name">
          <div class="routeBG">
            <div style="padding: 8px 12px">
              <div class="routeS">
                <van-image width="20" height="20" :src="require('../../assets/img1.svg')"/>
                <div style="padding:0 8px;">路线{{value.name}}: {{value.detail}}</div>
                <van-tag round color="#FEB013">标准路线</van-tag>
              </div>            
            </div>
          </div>
          <van-loading v-if="dataloading" size="24px" style="text-align: center;margin: 20% 0;">加载中...</van-loading>
          <template v-else >
            <van-pull-refresh v-model="isLoading" @refresh="getRouteListByStatus">
              <div v-if="!routeType[active].counts" style="text-align: center;margin:20% 0;">
                <van-image width="80" :src="require('../../assets/none.svg')"/>
                <div style="font-size: 12px;">暂无拼车</div>
              </div>
              <div class="carInfoCard" v-for="(item, key) in routeList[active]" :key="key">
                <div class="routeBox">
                  <div class="timebox">
                    <div class="time">今天 {{item.DepartTime}}</div>
                    <div style="display:flex;">
                      <van-image width="20" height="20" :src="require('../../assets/img2.svg')"/>
                      <div class="carperson">已拼{{item.passengers.length}}人</div>
                    </div>
                  </div>
                  <div class="list-box">
                    <div class="list-route">路线{{item.Route}}</div>
                    <div class="list-text">{{item.Origin}}</div>
                    <div style="color: #999999;">------</div>
                    <div class="list-text">{{item.Destination}}</div>
                  </div>
                  <div class="list-way">途径  {{item.Way}}</div>
                  <div class="driver-box">
                    <div style="display: flex;align-items: center;">
                      <van-image width="40" height="40" round :src="item.Avatar"/>
                      <div style="padding-left:8px;">
                        <div style="font-weight: bold;">{{item.Name}}  {{item.CarNum}}</div>
                        <div style="font-size:12px;">({{item.Car}} | {{item.CarSeat}}座)</div>
                      </div>
                    </div>
                    <van-button color="#333333" round class="passenger-btn" :disabled="driverOrder" @click="selectCar(item._id)">拼车</van-button>
                  </div>
                </div>
              </div>
              <!-- <div style="height: 100px;background-color: #F5F5F5;"></div> -->
            </van-pull-refresh>            
          </template>
        </van-tab>
      </van-tabs>
    </template>
    <template v-else>
      <div class="driver-card">
        <div class="setRoute" @click="showRoute = !driverOrder">
          <van-image width="20" height="20" :src="require('../../assets/img1.svg')" style="top:5px;"/>
          <a>{{routeTitle}}</a>
          <van-icon name="arrow" style="float:right;top:5px;"/>
        </div>
        <van-form @submit="onSubmit" label-width="60" :disabled="driverOrder">
          <div class="routebox">
            <div class="start-icon">起</div>
            <a style="padding:0 8px;font-weight: 600;width: 12%;">公司</a>
            <div style="width: 10%;padding-right: 8px;">
                <div class="center-text"></div>
            </div>
            <div class="end-icon">终</div>
            <a style="padding:0 8px;font-weight: 600;width: 40%;">
              <van-field v-model="routeData.Destination" placeholder="请填写目的地" clearable :border="false" :rules="[{ required: true }]"/>
            </a>
          </div>
          <van-field v-model="routeData.Way" label="途径" placeholder="多个途径地用空格键分开" clearable :rules="[{ required: true }]"/>
          <van-field
            v-model="routeData.DepartTime"
            label="时间"
            placeholder="请选择时间"
            readonly
            clearable
            right-icon="arrow"
            @click="showPicker = !driverOrder"
            :rules="[{ required: true }]"/>
          <van-field v-model="routeData.CarSeat" label="座位" placeholder="请填写可乘坐座位数" type="digit" clearable :rules="[{ pattern, required: true, message:'座位数不能为0' }]"/>
          <van-field v-model="routeData.Remark" label="备注" placeholder="(选填)填写备注" clearable />
          <van-button color="#FEB013" round block :disabled="driverOrder" :loading="driverbBtn" class="submit-btn">发布拼车</van-button>
          <div style="text-align: center;font-size: 12px;margin: 8px 0;">
            <van-icon name="checked" />
            <a>健帆内部拼车服务保障</a>
          </div>
        </van-form>

      </div>

    </template>
    <template v-if="driverOrder">
      <div style="height:60px;"></div>
      <div class="quick-driver" @click="goTo(orderId)">
        <van-image width="20" height="20" :src="require('../../assets/img1.svg')" style="top:5px;"/>
        <a>您有1个拼车订单进行中...</a>
        <van-icon name="arrow" style="float:right;top:5px;"/>
      </div>      
    </template>
    <div class="company">由营销信息部提供技术支持</div>
    
    <van-popup v-model="showPicker" position="bottom">
      <van-datetime-picker
        type="time"
        :min-hour="minHour"
        @confirm="onConfirmTime"
        @cancel="showPicker = false"
      />
    </van-popup>

    <van-popup v-model="showRoute" round position="bottom">
      <van-radio-group v-model="Radio" style="margin-top: 20px;">
        <div
          v-for="(item, key) in RList" :key="key"
          class="radioBox"
          @click="checkRadio(item)"
          :style="item.name === Radio ?'background-color: rgba(254, 176, 19, 0.1);':'background-color: #F5F5F5;'">
          <div style="display: flex;align-items: center;">
            <van-image width="20" height="20" :src="require('../../assets/img1.svg')"/>
            <div>路线{{item.name}}:{{item.detail}}</div>            
          </div>
          <van-radio :name="item.name" checked-color="#FEB013"/>
        </div>
      </van-radio-group>
      <div style="margin: 20px 20px 40px 20px;">
        <van-button round block color="#FEB013" @click="showRoute = false">保存变更</van-button>
      </div>
    </van-popup>

    <van-popup v-model="showDriver" round position="bottom" safe-area-inset-bottom style="height: 290px;">
      <div class="routeBox" style="margin:0;">
        <div class="timebox">
          <div class="time">今天 {{driverInfo.DepartTime}}</div>
          <div style="display:flex;">
            <van-image width="20" height="20" :src="require('../../assets/img2.svg')"/>
            <div class="carperson">已拼{{driverInfo.passengers?driverInfo.passengers.length:0}}人</div>
          </div>
        </div>
        <div class="list-box">
          <div class="list-route">路线{{driverInfo.Route}}</div>
          <div class="list-text">{{driverInfo.Origin}}</div>
          <div style="color: #999999;">------</div>
          <div class="list-text">{{driverInfo.Destination}}</div>
        </div>
        <div class="list-way">途径  {{driverInfo.Way}}</div>
        <div style="padding:4px 0">
            <van-icon name="medal" color="#C9C9C9"/>
            <a style="font-size: 12px;">{{driverInfo.Remark?driverInfo.Remark:'司机没有填写备注哦~'}}</a>
        </div>
        <div class="driver-box">
          <div style="display: flex;align-items: center;">
            <van-image width="40" height="40" round :src="driverInfo.Avatar"/>
            <div style="padding-left:8px;">
              <div style="font-weight: bold;">{{driverInfo.Name}}  {{driverInfo.CarNum}}</div>
              <div style="font-size:12px;">({{driverInfo.Car}} | {{driverInfo.CarSeat}}座)</div>
            </div>
          </div>
          <a style="text-align: center;color: black;" :href="'tel://' + driverInfo.Phone">
            <van-icon name="phone" size="32" color="#FEB013"/>
            <div style="font-size:12px;">联系司机</div>
          </a>
          
        </div>
        <div>
          <van-button color="#333333" round block class="confirm-btn" :loading="driverbBtn" @click="onConfirm(driverInfo)">确认拼车</van-button>
          <!-- <div style="font-size:12px;display:flex;align-items: center;justify-content: center;">
            <van-icon name="bell" color="#FEB013"/>
            <div>疫情期间，请带好口罩出行 </div>
          </div> -->
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      role: '',
      active: 0,
      showDriver: false,
      showRoute: false,
      Radio: '',
      routeTitle: '请设置路线',
      routeData: {},
      showPicker: false,
      minHour: new Date().getHours(),
      driverOrder: false,
      orderId: '',
      driverbBtn: false,
      routeList: [[],[],[],[],[],[],[]],
      routeType: [],
      isLoading: false,
      dataloading: false,
      driverInfo: {},
      pattern: /^[1-9]$/,
      screenHeight: document.documentElement.clientHeight,
      RList: []
    }
  },
  // watch: {
  //   'screenHeight': function (val) {
  //     console.log('val',val)
  //     console.log(document.documentElement.clientHeight)
  //     // if (val >= 724) {
  //     //   this.screenHeight = val -84
  //     // } else {
  //     //   this.screenHeight = val - 50
  //     // }
  //   }
  // },
  async mounted() {
    if (this.screenHeight >= 724) {
      this.screenHeight = this.screenHeight -84
    } else {
      this.screenHeight = this.screenHeight - 50
    }
    // const test = {"errno":0,"data":{"area":"健树","errcode":0,"errmsg":"ok","userid":"201755101","name":"吴昌悦","department":[2267],"position":"软件开发工程师","mobile":"15812615614","gender":"1","email":"wuchangyue@jianlianmed.com","avatar":"http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/0","status":1,"isleader":0,"extattr":{"attrs":[{"name":"英文名","value":"","type":0,"text":{"value":""}},{"name":"工号","value":"2017551","type":0,"text":{"value":"2017551"}},{"name":"身份证","value":"","type":0,"text":{"value":""}}]},"english_name":"","telephone":"020-88985632","enable":1,"hide_mobile":0,"order":[0],"external_profile":{"external_attr":[],"external_corp_name":""},"main_department":2267,"qr_code":"https://open.work.weixin.qq.com/wwopen/userQRCode?vcode=vc5b6c10860443246c","alias":"","is_leader_in_dept":[0],"address":"","thumb_avatar":"http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/100","direct_leader":[],"openid":"ozAQBt9Jauj5fMYuM9Q0bNmhaAo8","access_token":"hER4OJaZReJSc_9Mi6NCJTXyliK2QkEDuj0ruK4CsiFGKySTq81qK6AsR7GqX6bROcq28TctrjQqtXheO0mKenvkX6pu6kkuP9cSO51qDnBHwnOThgl4thnSeAFw_PlA0aUdAX3tE5yPHs3IIgOwB4bEc6yFKchMe7tjjaACla90dBlIe8j8JuSB-SOLpoWVXMI36ulQW7uRs6VXRfH57w"}}
    // this.WXInfo = test.data
    this.WXInfo = JSON.parse(localStorage.getItem('userinfo')).data
    if (this.WXInfo.userid) {
      this.dataloading = true
      // 路线列表识别
      this.RList = this.WXInfo.area === '健树' ? this.$JSRoute : this.$Route

      // 特殊人员处理
      if (this.WXInfo.name === '杨阳') {
        this.RList = this.$Route
      }

      this.role = localStorage.getItem('Role') ? localStorage.getItem('Role') : null
      if (!this.role) {
        const result = await this.getUserInfo(this.WXInfo.userid)
        if (result.data.length > 0) {
          localStorage.setItem('Role', result.data[0].Role)
          localStorage.setItem('Phone', result.data[0].Phone)
          this.role = result.data[0].Role
          this.checkRole(this.role)
        } else {
          this.$router.push('/login?role=passenger&register=false')
        }
      } else {
        this.checkRole(this.role)
      }
    } else {
      // 重置access_token,重新授权登录
      localStorage.removeItem('access_token')
      localStorage.removeItem('userinfo')
      localStorage.removeItem('Role')
      this.$router.push('/index')
    }
  },
  methods: {
    setMessage(item) {
      if (!item || !item._id || !item.SubscribeUser || !item.SubscribeUser.length) {
        return
      }

      let message = '司机发布通知：\n日期：' + item.DateTime + ' ' + this.$moment(new Date()).format('HH:mm') +
        '\n路线：' + item.Route + 
        '\n行程：公司出发到' + this.routeData.Destination +
        '\n司机：' + item.Name +
        '\n电话：<a href="tel:' + item.Phone + '">' + item.Phone + '</a>' +
        '\n\n'+
        '<a href="https://pinche.jafron.com/index?route='+ item.Route +'&userid='+ item.UserId +'&date='+item.DateTime+'&id='+ item._id +'">拼车</a>'
      this.postSendMessage(item.SubscribeUser.join('|'), message)
    },
    async getOrderData () {
      let result = {}
      const query = {
        // OpenId: this.WXInfo.openid,
        UserId: this.WXInfo.userid,
        DateTime: this.$moment(new Date()).format('YYYY-MM-DD')
      }
      if (this.role === 'passenger') {
        result = await this.getPassengerData(query)
      } else {
        result = await this.getAllRouteList(query)
      }
      if (result.data.length === 0) {
        return true
      // } else if (result.data.length === 1) {
      //   if (this.WXInfo.area === '天津') { //判断用户是否天津标准用户
      //     return true
      //   } else {
      //     return false
      //   }
      } else {
        return false
      }
    },
    async onConfirm (item) {
      if (!item || !item._id) {
        this.$toast('行程信息异常，请从列表重新选择')
        this.driverbBtn = false
        this.showDriver = false
        return
      }
      const isNext = await this.getOrderData()
      if (isNext) {
        this.driverbBtn = true
        try {
          const data = {
            Name: this.WXInfo.name,
            // OpenId: this.WXInfo.openid,
            UserId: this.WXInfo.userid,
            DriverId: item.UserId,
            Phone: localStorage.getItem('Phone'),
            ParentsId: item._id,
            DateTime: this.$moment(new Date()).format('YYYY-MM-DD'),
            Status: '已拼车'
          }
          const result = await this.postPassengerInfo(item._id, data)
          this.$toast(result.message)
          if (result.success) {
            this.goTo(item._id)

            let message = '乘客确认通知：\n日期：' + item.DateTime + ' ' + this.$moment(new Date()).format('HH:mm') +
              '\n路线：' + item.Route + ' 公司出发到' + item.Destination +
              '\n乘客：' + data.Name +
              '\n电话：<a href="tel:' + data.Phone + '">' + data.Phone + '</a>' +
              '\n\n请确认乘客上车后在出发。\n\n'+
              '<a href="https://pinche.jafron.com/detail?role=driver&userid='+ item.UserId +'&id='+ item._id +'">现在发车</a>'
            this.postSendMessage(item.UserId, message)
          }
        } finally {
          this.driverbBtn = false
        }
      } else {
        this.$toast('今天拼车次数已用完，无法拼车。')
      }

    },
    findShareTravel (list) {
      const travelId = this.$route.query.id
      const driverUserId = this.$route.query.userid
      let matched = null
      if (travelId) {
        matched = list.find(item => String(item._id) === String(travelId))
      }
      // 旧推送可能没有 id，或司机取消后重发导致旧 id 失效，回退按司机工号匹配
      if (!matched && driverUserId) {
        matched = list.find(item => item.UserId === driverUserId)
      }
      return matched && matched._id ? matched : null
    },
    async checkRole (data) {
      const isShareEntry = this.$route.query.route &&
        this.$route.query.date === this.$moment(new Date()).format('YYYY-MM-DD') &&
        (this.$route.query.userid || this.$route.query.id)

      // 分享链接进入时，按乘客流程打开对应行程，便于快速拼车
      if (isShareEntry) {
        this.role = 'passenger'
        const active = parseInt(localStorage.getItem('active'))
        this.active = active ? active : 0
        this.routeType = this.RList
        this.active = this.routeType.findIndex(item => item.name === this.$route.query.route)
        if (this.active < 0) this.active = 0
        await this.getRouteListByStatus()

        const result = await this.getPassengerInfo()
        if (result.success) {
          this.driverOrder = true
          this.orderId = result.data.ParentsId
          this.$toast('您今天已有拼车订单')
        } else {
          const matched = this.findShareTravel(this.routeList[this.active] || [])
          if (matched) {
            this.driverInfo = matched
            this.showDriver = true
          } else {
            this.driverInfo = {}
            this.showDriver = false
            this.$toast('未找到可拼行程，可能已满座或已取消')
          }
        }
        return
      }

      if (data === 'driver') {
        this.getDriverTravel()
      } else {
        const active = parseInt(localStorage.getItem('active'))
        this.active = active ? active : 0

        this.routeType = this.RList
        if (this.$route.query.route) {
          this.active = this.routeType.findIndex(item => item.name === this.$route.query.route)
        }
        await this.getRouteListByStatus()

        const result = await this.getPassengerInfo()
        if (result.success) {
          this.driverOrder = true
          this.orderId = result.data.ParentsId
        }
      }
    },
    selectCar (val) {
      const matched = (this.routeList[this.active] || []).find(item => String(item._id) === String(val))
      if (matched && matched._id) {
        this.driverInfo = matched
        this.showDriver = true
      } else {
        this.driverInfo = {}
        this.showDriver = false
        this.$toast('未找到可拼行程，可能已满座或已取消')
      }
    },
    checkTab () {
      this.dataloading = true
      this.getRouteListByStatus()
    },
    async getRouteListByStatus () {
      // this.isLoading = true
      localStorage.setItem('active', this.active)
      const data = {
        Route: this.RList[this.active].name,
        DateTime: this.$moment(new Date()).format('YYYY-MM-DD'),
        Status: '已发布'
      }
      const result = await this.getAllRouteList(data)
      this.routeList[this.active] = result.data
      this.routeType[this.active].counts = result.count
      setTimeout(() => {
        this.isLoading = false
        this.dataloading = false
      }, 1000)
    },
    async onSubmit() {
      const isNext = await this.getOrderData()
      if (isNext) {
        this.driverbBtn = true
        try {
          delete this.routeData.CreateTime
          delete this.routeData.UpDateTime
          delete this.routeData._id
          this.routeData.Car = this.routeData.Status === '已取消' ? this.routeData.Car : this.routeData.CarColor +' '+ this.routeData.CarBrand + this.routeData.CarName
          this.routeData.DateTime = this.$moment(new Date()).format('YYYY-MM-DD')
          this.routeData.Status = '已发布'
          console.log('this.routeData', this.routeData)

          const result = await this.postAddTravel(this.routeData)
          this.$toast(result.message)
          if (result.success && result.data._id) {
            this.driverOrder = true
            this.orderId = result.data._id

            this.postUpdateRoute(this.routeData) // 更新默认路线
            // 推送必须带上新建行程 _id，否则乘客点链接无法定位行程
            this.setMessage(Object.assign({}, this.routeData, { _id: result.data._id }))
            this.goTo(result.data._id)
          }
        } finally {
          this.driverbBtn = false
        }
      } else {
        this.$toast('今天拼车次数已用完，无法拼车。')
      }

    },
    goTo(val) {
      this.$router.push('/detail?role=' + this.role+'&id='+val)
    },
    checkRadio (value) {
      this.Radio = value.name
      this.routeData.Route = value.name
      this.routeTitle = '路线'+value.name+':'+value.detail
      this.showRoute = false
    },
    onConfirmTime (val) {
      if (val > this.$moment(new Date()).format('HH:mm')) {
        this.routeData.DepartTime = val
        this.showPicker = false
      } else {
        this.$toast('当前时间大于设置时间，重新选择')
      }
    },
    async getDriverRouteInfo() {
      const result = await this.getDriverRoute(this.WXInfo.userid)
      if (result.success) {
        this.routeData = result.data
        this.routeTitle = '路线'+this.routeData.Route+':'+this.RList.find(value=>value.name === this.routeData.Route).detail
        this.Radio = this.routeData.Route
      } else {
        // 重置access_token,重新授权登录
        localStorage.removeItem('access_token')
        localStorage.removeItem('Role')
        this.$router.push('/login?register=true')
      }
    },
    async getDriverTravel() {
      let qarams = {
        // OpenId: this.WXInfo.openid,
        UserId: this.WXInfo.userid,
        DateTime: this.$moment(new Date()).format('YYYY-MM-DD'),
        // Status: '已发布'
      }
      const result = await this.getAllRouteList(qarams)
      if (result.data.length > 0 ) {
        this.orderId = result.data[0]._id
        this.routeData = result.data[0]
        this.routeTitle = '路线'+this.routeData.Route+':'+this.RList.find(value=>value.name === this.routeData.Route).detail
        this.Radio = this.routeData.Route
        this.driverOrder = this.routeData.Status !== '已发车'
      } else {
        this.getDriverRouteInfo()
      }
    },
    // 查询用户基础数据
    getUserInfo(data) {
      return this.$request({
        url: this.$api.getUserInfo,
        method: 'GET',
        params: {
          // OpenId: data,
          UserId: data
        }
      })
    },
    // 查询司机路线信息
    getDriverRoute(data) {
      return this.$request({
        url: this.$api.getDriverRoute,
        method: 'GET',
        params: {
          UserId: data
        }
      })
    },
    getAllRouteList(data) {
      return this.$request({
        url: this.$api.getAllRouteList,
        method: 'GET',
        params: data
      })
    },
    getPassengerInfo() {
      return this.$request({
        url: this.$api.getPassengerByOpenid,
        method: 'GET',
        params: {
            // OpenId: this.WXInfo.openid,
            UserId: this.WXInfo.userid,
            Status: '已拼车',
            DateTime: this.$moment(new Date()).format('YYYY-MM-DD')
        }
      })
    },
    postAddTravel(data) {
      return this.$request({
        url: '/api/UserCar/postAddTravel',
        method: 'POST',
        params: {
          // OpenId: this.WXInfo.openid,
          UserId: this.WXInfo.userid,
          Status: '已发布',
          DateTime: this.$moment(new Date()).format('YYYY-MM-DD')
        },
        data
      })
    },
    postPassengerInfo (id, data) {
      return this.$request({
        url: this.$api.postPassengerInfo,
        method: 'POST',
        params: {
          // OpenId: this.WXInfo.openid,
          UserId: this.WXInfo.userid,
          ParentsId: id
        },
        data
      })
    },
    async postSendMessage(userid, message) {
      const result = await this.$request({
        url: this.$api.postSendMessageWX,
        method: 'POST',
        data: {
          'touser': userid,
          'msgtype': 'text',
          'agentid': this.$agentid,
          'text': { 'content': message }
        }
      })
      if (!result.success) {
        this.$toast(result.message)
      }
    },
    getPassengerData(data) {
        return this.$request({
            url: this.$api.getPassengerList,
            method: 'GET',
            params: data
        })
    },
    async postUpdateRoute (data) {
      const value = {
        Route: data.Route,
        Destination: data.Destination,
        Way: data.Way,
        DepartTime: data.DepartTime,
        Remark: data.Remark ? data.Remark : ''
      }
      await this.$request({
        url: this.$api.postUserRoute,
        method: 'POST',
        params: {
            UserId: this.WXInfo.userid
        },
        data: value
      })
    }
  }
}
</script>

<style lang="less" scoped>
  #main {
    overflow-y: scroll;
  }
  /deep/.van-cell {
    padding: 16px 0;
    font-size: 16px;
  }
  /deep/.van-radio__icon .van-icon {
    border: initial;
  }
  .routeBG {
    background-color: #ffffff;
    font-size: 14px;
  }
  .routeS {
    border-radius: 4px;
    padding:6px 7px;
    background: rgba(254, 176, 19, 0.1);
    display: flex;
    align-items: center;
  }
  .carInfoCard {
    background-color: #F5F5F5;
    overflow:hidden;
    line-height: 1.5;
  }
  .routeBox {
    margin:4px 12px;
    padding: 12px;
    background: #FFFFFF;
    border-radius: 4px;
  }
  .timebox {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .time {
    font-weight: bold;
    font-size: 18px;
  }
  .carperson {
    font-size: 12px;
    color: #F22222;
  }

  .driver-card {
    margin: 8px 12px;
    background-color: #ffffff;
    padding: 12px;
    border-radius: 4px;
  }
  .routebox {
      padding: 8px 0;
      border-bottom:1px dashed #D2D2D2;
      display: flex;
      align-items: center;
  }
  .start-icon {
      font-size: 13px;
      height: 20px;
      width: 20px;
      background-color: #39A0F4;
      color: #ffffff;
      border-radius: 50%;
      padding: 4px;
      text-align: center;
  }
  .center-text {
      border-bottom: 1px dashed #999999;
      margin: 10% 0px;
      font-size: 14px;
      font-weight: initial;
  }
  .end-icon {
      font-size: 13px;
      height: 20px;
      width: 20px;
      background-color: #4DBE86;
      color: #ffffff;
      border-radius: 50%;
      padding: 4px;
      text-align: center;
  } 
  .setRoute {
      background-color: #F5F5F5;
      border-radius: 4px;
      padding: 16px 8px;
      margin-bottom: 8px;
  }
  .radioBox {
    display: flex;
    justify-content: space-between;
    /* background-color: #F5F5F5; */
    border-radius: 4px;
    padding: 16px 12px;
    margin: 12px;
    font-size: 15px;
    font-weight: bold;
  }
  .quick-driver {
    line-height: 1.5;
    margin: 8px 12px;
    background-color: rgba(51, 51, 51, 0.8);
    padding: 8px 12px;
    border-radius: 4px;
    color: #FFFFFF;
    position: fixed;
    width: 86.5%;
    bottom: 12%;
  }
  .submit-btn {
    margin:25px 0 5px 0;
    font-size: 15px;
    font-weight: bold;
  }
  .list-box {
    display:flex;
    align-items: center;
  }
  .list-route {
    border:1px solid #999999;
    color:#999999;
    border-radius:4px;
    padding: 1px 4px;
    font-size: 14px;
  }
  .list-text {
    padding:0 8px;
    font-size: 15px;
    font-weight: 600;
  }
  .list-destina {
    padding:0 8px;font-size: 15px;font-weight: 600;
  }
  .driver-box {
    border-top: 1px solid #D2D2D2;
    padding-top:8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .list-way {
    padding: 4px 0;
    font-size:12px;
  }
  .passenger-btn {
    width: 30%;
    font-size: 15px;
    font-weight: bold;
  }
  .confirm-btn {
    margin:25px 0 5px 0;
    font-size: 15px;
    font-weight: bold;
  }
  .company {
    text-align: center;
    color: #999999;
    font-size: 12px;
    margin-bottom: 10px;
  }
</style>
